import React from "react"
import Image from "gatsby-image"
import styled from "styled-components"
import { Row, Col, Card } from "react-bootstrap"
import Parser from "html-react-parser"

let SpeakerRowThreeTwo = props => {
  return (
    <>
      <section
        style={{
          backgroundColor: props.colorSpeaker,
          marginTop: "5rem",
          paddingBottom: `${props.paddingSpeaker ? "4rem" : "0rem"}`,
        }}
      >
        <Row style={{ justifyContent: "center" }}>
          <Title style={{ color: props.colorTextSpeaker }}>
            <b> {props.speakerTitle}</b>
          </Title>
        </Row>
        <RowSpeakers className="row">
          <DivSpeakers className="col-xl-3 col-lg-12 col-md-8 col-sm-8  ">
            <div
              style={{
                width: "80%",
                marginRight: "auto",
                marginLeft: "auto",
              }}
            >
              <Image
                className="rounded-lg"
                fluid={props.fluidSpeakerOne}
                alt={props.nameSpeakerOne}
              ></Image>
            </div>
            <DivTextTwo>
              <h4 style={{ color: props.colorTextSpeaker }}>
                {props.nameSpeakerOne}
              </h4>
              {/*   <p>{Parser(props.jobSpeakerOne)}</p> */}
              <p style={{ color: props.colorTextSpeaker }}>
                {Parser(props.companySpeakerOne)}
              </p>
            </DivTextTwo>
            <div
              style={{
                width: "100%",
                maxWidth: "100px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <a href={props.linkSpeakerOne}>
                <Image
                  fluid={props.LinkIcon}
                  style={{
                    width: "50px",
                    margin: "auto",
                    marginTop: "1rem",
                  }}
                  alt={props.nameSpeakerOne}
                ></Image>
              </a>
            </div>
          </DivSpeakers>

          <DivSpeakers className="col-xl-3 col-lg-12 col-md-8 col-sm-8">
            <div
              style={{
                width: "80%",
                marginRight: "auto",
                marginLeft: "auto",
              }}
            >
              <Image
                fluid={props.fluidSpeakerTwo}
                alt={props.nameSpeakerTwo}
              ></Image>
            </div>
            <DivTextTwo>
              <h4 style={{ color: props.colorTextSpeaker }}>
                {props.nameSpeakerTwo}
              </h4>
              {/*  <p>{Parser(props.jobSpeakerTwo)}</p> */}
              <p style={{ color: props.colorTextSpeaker }}>
                {Parser(props.companySpeakerTwo)}
              </p>
            </DivTextTwo>
            <div
              style={{
                width: "100%",
                maxWidth: "100px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <a href={props.linkSpeakerTwo}>
                <Image
                  fluid={props.LinkIcon}
                  style={{
                    width: "50px",
                    margin: "auto",
                    marginTop: "1rem",
                  }}
                  alt={props.nameSpeakerTwo}
                ></Image>
              </a>
            </div>
          </DivSpeakers>
          {props.nameSpeakerThree && (
            <DivSpeakers className="col-xl-3 col-lg-12 col-md-8 col-sm-8">
              <div
                style={{
                  width: "80%",
                  marginRight: "auto",
                  marginLeft: "auto",
                }}
              >
                <Image
                  fluid={props.fluidSpeakerThree}
                  alt={props.nameSpeakerThree}
                ></Image>
              </div>
              <DivTextTwo>
                <h4 style={{ color: props.colorTextSpeaker }}>
                  {props.nameSpeakerThree}
                </h4>
                {/*  <p>{Parser(props.jobSpeakerThree)}</p> */}
                <p style={{ color: props.colorTextSpeaker }}>
                  {Parser(props.companySpeakerThree)}
                </p>
              </DivTextTwo>
              <div
                style={{
                  width: "100%",
                  maxWidth: "100px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <a href={props.linkSpeakerThree}>
                  <Image
                    fluid={props.LinkIcon}
                    style={{
                      width: "50px",
                      margin: "auto",
                      marginTop: "1rem",
                    }}
                    alt={props.nameSpeakerThree}
                  ></Image>
                </a>
              </div>
            </DivSpeakers>
          )}
        </RowSpeakers>
        {props.nameSpeakerFour && (
          <RowSpeakers className="row">
            {props.nameSpeakerFour && (
              <DivSpeakers className="col-xl-3 col-lg-12 col-md-8 col-sm-8">
                <Image
                  fluid={props.fluidSpeakerFour}
                  alt={props.nameSpeakerFour}
                ></Image>

                <h4>{props.nameSpeakerFour}</h4>
                <p>{props.jobSpeakerFour}</p>
                <p>{props.companySpeakerFour}</p>

                <a href={props.linkSpeakerFour}>
                  <Image
                    fluid={props.LinkIcon}
                    style={{
                      width: "50px",
                      margin: "auto",
                      marginTop: "1rem",
                    }}
                    alt={props.nameSpeakerFour}
                  ></Image>
                </a>
              </DivSpeakers>
            )}
            {props.nameSpeakerFive && (
              <DivSpeakers className="col-xl-3 col-lg-12 col-md-8 col-sm-8">
                <Image
                  fluid={props.fluidSpeakerFive}
                  alt={props.nameSpeakerFive}
                ></Image>

                <h4>{props.nameSpeakerFive}</h4>
                <p>{props.jobSpeakerFive}</p>
                <p>{props.companySpeakerFive}</p>

                <a href={props.linkSpeakerFive}>
                  <Image
                    fluid={props.LinkIcon}
                    style={{
                      width: "50px",
                      margin: "auto",
                      marginTop: "1rem",
                    }}
                    alt={props.nameSpeakerFive}
                  ></Image>
                </a>
              </DivSpeakers>
            )}
          </RowSpeakers>
        )}
        {props.titleModerator && <Title>{props.titleModerator}</Title>}

        {props.nameSpeakerSix && (
          <RowSpeakers className="row">
            <DivSpeakers className="col-xl-3 col-lg-12 col-md-6 col-sm-6">
              <Image
                fluid={props.fluidSpeakerSix}
                alt={props.nameSpeakerSix}
              ></Image>
              <DivText className="">
                <h4>{props.nameSpeakerSix}</h4>
                <p>{props.jobSpeakerSix}</p>
                <p>{props.companySpeakerSix}</p>
              </DivText>
              <a href={props.linkSpeakerSix}>
                <Image
                  fluid={props.LinkIcon}
                  style={{
                    width: "50px",
                    margin: "auto",
                    marginTop: "1rem",
                  }}
                  alt={props.nameSpeakerSix}
                ></Image>
              </a>
            </DivSpeakers>
          </RowSpeakers>
        )}
      </section>
    </>
  )
}

export default SpeakerRowThreeTwo

const RowSpeakers = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 90%;
  margin-top: 3rem;
  justify-content: center;
  @media (max-width: 400px) {
    margin-top: 1rem;
  }
`
const DivSpeakers = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 500px;
  height: 35rem;

  h4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-weight: bold;
    color: white;
  }
  p {
    margin: 0;
    font-size: 1.2rem;
    color: white;
  }
  @media (max-width: 700px) {
    p {
      font-size: 1rem;
    }
  }
  @media (max-width: 767px) {
    height: 100%;
  }
`
const Title = styled.h1`
  font-weight: 700;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  margin-top: 4rem;
  color: white;
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`
const DivText = styled.div`
  width: 20rem;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 991px) {
    width: 100%;
  }
`
const DivTextTwo = styled.div`
  padding-left: 4rem;
  padding-right: 4rem;
  @media (max-width: 1600px) {
    padding-left: 0rem;
    padding-right: 0rem;
  }
`
